"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ImageVisor = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = require("react");

var _reactImageFallback = _interopRequireDefault(require("react-image-fallback"));

var _styles = require("./styles.js");

var _ImageUploader = _interopRequireDefault(require("../ImageUploader"));

var _utils = require("../../../global-files/utils.js");

var _defaultProductImage = _interopRequireDefault(require("../../../assets/images/defaultImages/defaultProductImage.png"));

var _fullscreen = _interopRequireDefault(require("../../../assets/images/Icons/fullscreen.svg"));

var _close = _interopRequireDefault(require("../../../assets/images/Icons/close.svg"));

var _uploadFile = _interopRequireDefault(require("../../../assets/images/Icons/upload-file.svg"));

var _deleteForeverWhite = _interopRequireDefault(require("../../../assets/images/Icons/delete-forever-white.svg"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["value", "name", "setModalFromTable", "setDataServices", "setModal"];

var ImageVisor = function ImageVisor(_ref) {
  var value = _ref.value,
      name = _ref.name,
      setModalFromTable = _ref.setModalFromTable,
      setDataServices = _ref.setDataServices,
      setModal = _ref.setModal,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(""),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      smallSrc = _useState2[0],
      setSmallSrc = _useState2[1];

  function handleNewImage(imageFile) {
    var payload = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, props), imageFile);
    setDataServices({
      type: "updateImage",
      payload: payload
    });
  }

  function handleUpdateImage(file) {
    if (file) {
      var reader = new FileReader();

      reader.onload = function () {
        getImageDimensions(reader.result);
      };

      reader.readAsDataURL(file);
    }
  }

  var getImageDimensions = function getImageDimensions(dataURL) {
    var img = new Image();

    img.onload = function () {
      var image = {
        src: dataURL,
        ext: img.src.includes("image/jpeg") ? "jpg" : "png",
        width: img.width,
        height: img.height
      };
      handleNewImage(image);
      changeVisor();
    };

    img.src = dataURL;
  };

  function changeVisor(view) {
    if (!view) {
      setModalFromTable(null);
      return;
    }

    var isSmall = view === "small";
    var src = isSmall ? smallSrc : "".concat(process.env.REACT_APP_IMAGES_ENDPOINT, "/").concat(value === null || value === void 0 ? void 0 : value.src);
    setModalFromTable( /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.ImageView, {
      visorView: view,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "header",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
          children: name
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "buttons",
          children: isSmall ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [value !== null && value !== void 0 && value.src ? /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _fullscreen.default,
              alt: "Ver en pantalla completa",
              onClick: function onClick() {
                return changeVisor("fullscreen");
              }
            }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              src: _close.default,
              alt: "Cerrar",
              onClick: function onClick() {
                return changeVisor();
              }
            })]
          }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("label", {
              className: "borderCircle",
              htmlFor: "fileInput",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
                src: _uploadFile.default,
                alt: "Actualizar imagen"
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
                type: "file",
                id: "fileInput",
                accept: "image/png, image/jpeg",
                style: {
                  display: "none"
                },
                onChange: function onChange(e) {
                  return handleUpdateImage(e.target.files[0]);
                }
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              className: "borderCircle",
              src: _deleteForeverWhite.default,
              alt: "Eliminar im\xE1gen",
              onClick: function onClick() {
                setModal({
                  type: "delete",
                  functions: {
                    setModal: setModal,
                    setDataServices: setDataServices
                  },
                  payload: props
                });
                changeVisor();
              }
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
              className: "borderCircle",
              src: _close.default,
              alt: "Cerrar",
              onClick: function onClick() {
                return changeVisor("small");
              }
            })]
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "body",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
          className: "imageLoaded",
          src: src,
          fallbackImage: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ImageUploader.default, {
            handleNewImage: handleNewImage
          }),
          alt: name !== null && name !== void 0 ? name : "Imagen del producto"
        })
      })]
    }));
  }

  (0, _react.useEffect)(function () {
    var _value$src;

    var src = value !== null && value !== void 0 && (_value$src = value.src) !== null && _value$src !== void 0 && _value$src.includes("image/") ? value === null || value === void 0 ? void 0 : value.src : (0, _utils.getImageURL)(process.env.REACT_APP_IMAGES_BUCKET, value === null || value === void 0 ? void 0 : value.src, 250, 250);
    setSmallSrc(src);
  }, [value]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageContainer, {
      onClick: function onClick() {
        return changeVisor("small");
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactImageFallback.default, {
        src: smallSrc,
        fallbackImage: _defaultProductImage.default,
        alt: name !== null && name !== void 0 ? name : "Imagen del producto"
      })
    })
  });
};

exports.ImageVisor = ImageVisor;
var _default = ImageVisor;
exports.default = _default;